import React, { createContext, useState, useEffect, useContext } from "react";
import SocketIOClient from "socket.io-client";
import { SERVER_ADDRESS } from "./src/docs/config.js";
import { AppContext } from "./AppContext.js";
import { ToastContext } from "./ToastContext.js";
import { NOTIFICATION_MESSAGES } from "./src/db/NotificationMessages.js";
import { AppState } from 'react-native';


export const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const [notiSocket, setNotiSocket] = useState(null);
  const [hasUnseenMessageNotifications, setHasUnseenMessageNotifications] =
    useState(false);
  const [hasUnseenGeneralNotifications, setHasUnseenGeneralNotifications] =
    useState(false);
  const { miID, token, language, updateToken } = useContext(AppContext);
  const { showMessageNotification } = useContext(ToastContext);
  const [hasUnseenNotifications, setHasUnseenNotifications] = useState(false);
  const [showNotificationDot, setShowNotificationDot] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [omitirProximaHVTP, setOmitirProximaHVTP] = useState(false);
  const handleSelectMessages = () => {
    setShowNotificationDot(false); // Oculta el globo en la NavBar
  };
  const [shouldFetchChats, setShouldFetchChats] = useState(false);
  const [nouToken, setNouToken] = useState(null);

  const [isSubscriptionOkVisible, setIsSubscriptionOkVisible] = useState(false);
  const clearNotifications = () => {
    setHasUnseenMessageNotifications(false);
    setHasUnseenGeneralNotifications(false);
    setShowNotificationDot(false);
  };
  const clearMessageNotificationsDot = () => {
    setHasUnseenMessageNotifications(false);
    setShowNotificationDot(hasUnseenGeneralNotifications); // Asegura que el dot solo se muestre para notificaciones generales si hay alguna
  };

  const handleSubscriptionSuccess = () => {
    
    setIsSubscriptionOkVisible(true);
    
  };

  const resetShouldFetchChats = () => {
    setShouldFetchChats(false);
  };

  const fetchChats = async () => {
    if (!miID) return;
    try {
      const response = await fetch(
        `${SERVER_ADDRESS}/api/v1/perfils/meusxats`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (data.status === "OK") {
        // Verificar si hay algún mensaje con estado "E"
        const hasUnreadMessages = data.data.some((chat) =>
          chat.missatges.some(
            (message) =>
              message.situacioMissatge === "E" && message.usuariEmisor !== miID
          )
        );
        // Actualizar el estado para mostrar el dot de notificación de mensaje nuevo
        setHasUnseenMessageNotifications(hasUnreadMessages);
      }
    } catch (error) {
      //console.error("Error fetching chats:", error);
    }
  };
  useEffect(() => {
    if (!miID) {
      return;
    }

    fetchChats();
  }, [miID]);

  // Función para obtener notificaciones pendientes y procesarlas
  const fetchNotifications = async () => {
    if (!token) {
      //console.log("Token no disponible aún.");
      return;
    }

    try {
      // console.log("Obteniendo notificaciones pendientes...");
      const response = await fetch(`${SERVER_ADDRESS}/api/v1/perfils/actuacions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          credentials: true,
        },
        body: JSON.stringify({ actuacio: "DN" }),
      });

      if (!response.ok) {
        //console.error("Error en la respuesta del servidor");
        return;
      }

      const jsonResponse = await response.json();
      if (jsonResponse.status === "OK") {
        const filteredNotifications = jsonResponse.data.filter(item => item.message.codi !== "EMCH")
          .map(item => item.message);

        const hasNotifications = filteredNotifications.length > 0;
        setHasUnseenGeneralNotifications(hasNotifications);
        setNotifications(prevNotifications => [...prevNotifications, ...filteredNotifications]
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
      }
    } catch (error) {
      //console.error("Error al obtener notificaciones pendientes:", error);
    }
  };

  // useEffect(() => {
  //   // Crear la suscripción
  //   const subscription = AppState.addEventListener('change', handleAppStateChange);
  
  //   // Función de limpieza
  //   return () => {
  //     // Comprobar si la suscripción existe y tiene el método 'remove'
  //     if (subscription && typeof subscription.remove === 'function') {
  //       subscription.remove();
  //     } else {
  //       console.error('La suscripción no se creó correctamente o el método remove no está disponible.');
  //     }
  //   };
  // }, []);

  // const handleAppStateChange = (nextAppState) => {
  //   if (nextAppState === 'active') {
  //     console.log('App has come to the foreground!');
  //     fetchNotifications(); // Asegúrate de que esta función actualiza las notificaciones correctamente
  //   }
  // };

  useEffect(() => {
    fetchNotifications(); // Obtener notificaciones pendientes al cambiar el token
  }, [token]);

  useEffect(() => {
    // Esta lógica asegura que el globo se muestre u oculte basado en las notificaciones actuales
    setShowNotificationDot(
      hasUnseenMessageNotifications || hasUnseenGeneralNotifications
    );
  }, [hasUnseenMessageNotifications, hasUnseenGeneralNotifications]);

  useEffect(() => {
    if (!token || notiSocket) {
      
      return;
    }


    const socket = SocketIOClient(SERVER_ADDRESS, {
      path: "/noti-socket",
      query: { token },
    });

    socket.on("connect", () => {
      //console.log("Conectado al servidor de notificaciones");
      socket.emit("join notis", { userId: miID });
      fetchChats();
    });

    socket.on("noti message", (noti) => {
      // Verifica si es la notificación de nueva suscripción PRO
      if (noti.codi === "novaSubscripcioPro") {
        handleSubscriptionSuccess();
        
        // Actualiza el token globalmente en AppContext
        if (noti.nouToken) {
          updateToken(noti.nouToken); // Esta línea actualiza el token globalmente
        }
      }

      // Mostrar notificación sin almacenarla si es de tipo "EMCH"
      if (noti.codi === "EMCH") {
        setHasUnseenMessageNotifications(true);
        setShouldFetchChats(true);
        const notificationMessage = NOTIFICATION_MESSAGES[noti.codi]
          ? NOTIFICATION_MESSAGES[noti.codi][language]
          : "Notificación desconocida";
        showMessageNotification(notificationMessage);
        return; // Finaliza la ejecución para no añadir al estado
      }

      // Manejar notificaciones NVAL
      if (noti.codi === "NVAL") {
        setOmitirProximaHVTP(true);
        setTimeout(() => setOmitirProximaHVTP(false), 20000); // Omitir HVTP solo por 5 segundos
      }

      // Verificar si se debe omitir esta notificación HVTP
      if (omitirProximaHVTP && noti.codi === "HVTP") {
        //console.log("Notificación HVTP omitida");
        return; // No procesar esta notificación
      }

      // Procesar y almacenar el resto de notificaciones normalmente
      setHasUnseenNotifications(true);
      setShowNotificationDot(true);
      setHasUnseenGeneralNotifications(true);

      const notificationMessage = NOTIFICATION_MESSAGES[noti.codi]
        ? NOTIFICATION_MESSAGES[noti.codi][language]
        : "Notificación desconocida";
      showMessageNotification(notificationMessage);

      // Fusionar y ordenar notificaciones, excluyendo EMCH
      setNotifications((prevNotifications) => {
        const updatedNotifications = [...prevNotifications, noti].filter(
          (n) => n.codi !== "EMCH"
        );
        updatedNotifications.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        return updatedNotifications;
      });
    });

    socket.on("disconnect", () => {
      //console.log("Desconectado del servidor de notificaciones");
    });

    setNotiSocket(socket);

    // Limpieza en desmontaje o cambio de token
    return () => {
      if (socket) {
        socket.disconnect();
        //console.log("Desconexión limpia al salir o cambiar el token");
      }
      setNotiSocket(null); // Asegura la eliminación del socket para prevenir múltiples instancias
    };
  }, [token]);

  // useEffect(() => {
  //   // Código para manejar la conexión Socket.IO...
  //   fetchNotifications(); // Obtener notificaciones pendientes al iniciar
  // }, [miID, token]);

  return (
    <SocketContext.Provider
      value={{
        notiSocket,
        hasUnseenMessageNotifications,
        setHasUnseenMessageNotifications,
        hasUnseenGeneralNotifications,
        setHasUnseenGeneralNotifications,
        showNotificationDot,
        setShowNotificationDot,
        handleSelectMessages,
        notifications,
        shouldFetchChats,
        resetShouldFetchChats,
        isSubscriptionOkVisible,
        setIsSubscriptionOkVisible,
        nouToken,
        setNouToken,
        clearNotifications,
        clearMessageNotificationsDot,
        fetchNotifications,

      }}
    >
      {children}
    </SocketContext.Provider>
  );
};
